export default __webpack_public_path__ + "static/media/educo.42287bdc.png";